/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Start_ButtonInputs */

const en_ocr_start_button = /** @type {(inputs: Ocr_Start_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start OCR`)
};

const fr_ocr_start_button = /** @type {(inputs: Ocr_Start_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrer l'OCR`)
};

const de_ocr_start_button = /** @type {(inputs: Ocr_Start_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR starten`)
};

const it_ocr_start_button = /** @type {(inputs: Ocr_Start_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvia OCR`)
};

const ru_ocr_start_button = /** @type {(inputs: Ocr_Start_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запуск OCR`)
};

const es_ocr_start_button = /** @type {(inputs: Ocr_Start_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar OCR`)
};

const zh_cn2_ocr_start_button = /** @type {(inputs: Ocr_Start_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始 OCR`)
};

const ja_ocr_start_button = /** @type {(inputs: Ocr_Start_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCRを開始する`)
};

const hi_ocr_start_button = /** @type {(inputs: Ocr_Start_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओसीआर शुरू करें`)
};

const pt_pt2_ocr_start_button = /** @type {(inputs: Ocr_Start_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar OCR`)
};

/**
* | output |
* | --- |
* | "Start OCR" |
*
* @param {Ocr_Start_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_start_button = /** @type {((inputs?: Ocr_Start_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Start_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_start_button(inputs)
	if (locale === "de") return de_ocr_start_button(inputs)
	if (locale === "it") return it_ocr_start_button(inputs)
	if (locale === "ru") return ru_ocr_start_button(inputs)
	if (locale === "es") return es_ocr_start_button(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_start_button(inputs)
	if (locale === "ja") return ja_ocr_start_button(inputs)
	if (locale === "hi") return hi_ocr_start_button(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_start_button(inputs)
	return en_ocr_start_button(inputs)
});